<template>
  <div class="file-upload">
    <!-- :fileList="fileList" -->
    <a-upload-dragger name="file" :headers="headers" :action="uploadAction"
      :customRequest="(file) => upLoadHander(file, false)" :accept="acceptData" :disabled="disabled" :fileKey="fileKey"
      :beforeUpload="beforeUpload" :multiple="mode == 'imgMode' ? true : multiple" listType="text"
      :showUploadList="mode == 'listMode'" :file-list="fileList" @preview="handlePreview" @change="handleChange">
      <div v-if="mode == 'imgMode' && fileList.length > 0" class="file-upload-wrap">
        <img v-if="isImg" :src="fileList[0].url" alt="image" />
        <div v-else class="flex-center" style="height: 100%; flex-direction: column; max-width: 360px;align-items: center;
    display: flex
;
    justify-content: center;">
          <a-icon type="profile" style="flex-shrink: 0; font-size: 40px;color:#000" />
          <div class="ellipsis" style="width: 100%; padding: 0px 10px;">{{ fileList[0].name || fileList[0].url }}</div>
        </div>
       <div class="hover-mask">
          <span class="ant-upload-list-item-actions">
            <!-- <a-icon type="gateway" v-if="!fileList[0].name.includes('.pdf')" @click.stop="handleCrop(fileList[0])" /> -->
            <!-- <a-icon style="margin-left: 10px;" type="eye" @click.stop="handlePreview(fileList[0])" /> -->
            <a-icon style="margin-left: 10px;" type="delete" v-if="!disabled" @click.stop="handleDelete(fileList[0])" />
          </span>
        </div>
      </div>
      <div v-else class="file-upload-wrap">
        <p class="ant-upload-drag-icon" style="margin-bottom: 0;">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">将文件拖到此处，或点击上传</p>
        <p class="ant-upload-hint" v-if="text">
          {{ text }}
        </p>
      </div>
    </a-upload-dragger>
    <!-- 预览弹窗 -->
    <!-- <template v-if="isClipShow">
      <clip-modal :disabled="disabled" ref="clip-modal" :clipWidth="clipWidth" :clipHeight="clipHeight"
        @close="isClipShow = false" @ok="saveImg" :img="clipImg"></clip-modal>
    </template>
    <JPreviewModal ref="JPreviewModal" /> -->
  </div>
</template>

<script>
import { uploadMixin } from './UploadMixin.js'
const uidGenerator = () => {
  return '-' + parseInt(Math.random() * 10000 + 1, 10)
}
const getFileName = (path) => {
  if (path.lastIndexOf('\\') >= 0) {
    let reg = new RegExp('\\\\', 'g')
    path = path.replace(reg, '/')
  }
  return path.substring(path.lastIndexOf('/') + 1)
}
export default {
  name: 'vatUpload',
  mixins: [uploadMixin],

  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    fileKey: {
      type: [String]
    },
    value: {
      type: [String, Array],
      required: false
    },
    accept: {
      type: [String, Object],
      default: '.png,.jpg,.jpeg,.pdf'
    },
    clipWidth: {
      type: Number,
      default: 395
    },
    clipHeight: {
      type: Number,
      default: 253
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    reviewHandle: {
      type: Function
    },
    pathMap: {
      type: Function
    },
    returnUrl: {
      type: Boolean,
      default: true
    },
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    //是否将pdf转成图片
    isPdfInImg: {
      type: Boolean,
      default: false
    },
    //是否支持截取图片
    isClip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clipImg: '',
      isClipShow: false,
      acceptData: '',
      uploadAction: '',
      headers: {},
      fileList: [],
      fileListShow: [],
      isImg: false,
      ids: [],
      typeName: '',
      // url: '/app/platform/uploadFile', // 后端不存在此接口，已注释
      mode: 'imgMode', // 'listMode'-列表模式 'upMode'-上传框模式  'imgMode'-上传图片模式
      text: '上传png,jpg,jpeg,pdf格式文件', // 文本提示展示
      number: 0,
      previewType: '',
      previewTitle: '',
      previewImage: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        console.log(val, 'val')
        if (this.fileList.length > 0) return //仅首次进行变更
        this.initVal(val)
      }
    }
  },
  created() {
    // 不传上传路径就统一用图片上传路径
    this.headers = {  }
    this.uploadAction = ''
    // 处理props
    const { typeName, url, mode, text, accept, number } = this.options
    this.typeName = typeName || this.typeName
    this.url = url || this.url
    this.mode = mode || this.mode
    this.text = text || this.text
    this.acceptData = accept || this.accept
    this.number = number || 0
    if (this.mode == 'listMode') {
      this.fileListShow = this.fileList
    } else this.fileListShow = []
    // 保留ids
    if (this.value && this.value instanceof Array) {
      let ids = []
      this.value.forEach((file) => {
        ids.push(file.id)
      })
      this.ids = ids
    }
  },
  methods: {
    initVal(val) {
      let paths = []
      if (val instanceof Array) {
        if (val.length > 0) {
          if (typeof this.pathMap === 'function') {
            paths = this.pathMap(val, true)
          } else if (!this.returnUrl) {
            paths = this.filePathMap(val, true)
          } else {
            paths = val.map((item) => {
              return { url: item.url || item.fileAddress || '' }
            })
          }
        }
      } else {
        if (val) {
          paths = val.split(',').map((v) => {
            return { url: v }
          })
        } else {
          paths = []
        }
      }
      console.log(paths, 'paths')
      this.initFileList(paths)
    },
    emitData(url) {
      return url ? this.$imgHttp(url) : ''
    },
    handleCrop(res) {
      console.log(res, 'res')
      this.isClipShow = true
      this.clipImg = this.$imgAgentHttp(res.url)
    },
    saveImg(res) {
      // 保存base64数据
      function dataURLtoBlob(dataurl) {
        var arr = dataurl.split(',')
        var mime = arr[0].match(/:(.*?);/)[1]
        var bstr = atob(arr[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new Blob([u8arr], { type: mime })
      }
      const blobDate = dataURLtoBlob(res)
      let params = {
        action: window._CONFIG['domianURL'] + '/sys/common/upload',
        headers: {  },
        data: { biz: 'signTemp' },
        file: blobDate,
        onProgress: (res) => { },
        onSuccess: (res) => {
          console.log(res,'dddd')
          this.initVal(res.result)
          this.handlePathChange()
          this.$nextTick(() => {
            this.isClipShow = false
          })
        },
        onError: () => {
          this.$message.error(`二维码保存失败!`)
        }
      }
      this.upLoadHander(params)
    },
    beforeUpload(file) {
      console.log('fileKey', file, this.fileKey)
      let that = this
      let fileSize = file.size
      let fileKey = this.fileKey
      // if (['frontIdcard', 'backIdcard', 'passport', 'businessLicenseImg', 'file-businessLicense', 'file-passport', 'file-frontIdCard', 'file-reverseIdCard'].includes(fileKey)) {
      //   if (['businessLicenseImg', 'file-businessLicense'].includes(fileKey) && fileSize > 1024 * 1024 * 8) {
      //     that.$notification['error']({
      //       message: '操作提醒',
      //       description: '文件或图片大小超过 8M,请重新上传文件！',
      //       duration: 8
      //     })
      //     that.fileList = []
      //     that.$emit('emitIsLt2MFile', fileKey)
      //     return false
      //   }
      //   if (!['businessLicenseImg', 'file-businessLicense'].includes(fileKey) && fileSize > 1024 * 1024 * 5) {
      //     that.$notification['error']({
      //       message: '操作提醒',
      //       description: '文件或图片大小超过 5M,请重新上传文件！',
      //       duration: 8
      //     })
      //     that.fileList = []
      //     that.$emit('emitIsLt2MFile', fileKey)
      //     return false
      //   }
      // }
      // let arr = (file.name || '.').split('.')
      // let pre = arr[arr.length - 1]
      // pre = pre.toLowerCase()
      // if (pre && ['png', 'jpg', 'jpeg', 'pdf'].includes(pre)) {
      //     const isLt2M = file.size / 1024 / 1024 < 9;
      //     if (!isLt2M) {
      //         this.$message.error('Image must smaller than 9MB!');
      //     }
      //     return  isLt2M;
      // }
      // return false;
    },
    initFileList(paths) {
      let fileList = []
      console.log(paths)
      paths.forEach((path) => {
        fileList.push({
          uid: uidGenerator(),
          id: path.id,
          name: path.name ,
          url: path.url,
          size: path.size,
          status: 'done',
          response: {
            status: 'history',
            message: path.url
          }
        })
      })
      if (this.mode == 'imgMode' && fileList.length > 0) {
        fileList = fileList.slice(fileList.length - 1)
          this.checkImg({ ...fileList[0], name: fileList[0].url })
      }
      this.fileList = fileList
    },
    async handleChange(info) {
      let that = this
      let fileList = JSON.parse(JSON.stringify(info.fileList))
      if (info.file.status === 'done') {
        if (this.number > 0) {
          fileList = fileList.slice(-this.number)
        }
        if (this.mode == 'imgMode') {
          fileList = fileList.slice(fileList.length - 1)
          this.checkImg(fileList[0])
        }
        if (this.listMode != 'listMode') {
          if (fileList.length > 0 ) {
            let url = fileList[0].response.result
            fileList[0].response.message = url
          }
        }

        if (info.file.response.success) {
          // if (this.mode == 'upMode') {
          //   const { name, size, response } = info.file
          //   const url = response.result
          //   this.$emit('change', url)
          //   return
          // }
          fileList = fileList.map((file) => {
            if (file.response) {
              file.url = file.response.result
            }
            return file
          })
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      } else if (info.file.status === 'removed') {
        this.handleDelete(info.file)
      }
      if (this.mode == 'listMode') {
        // this.fileList.push(fileList[0])
        this.fileList = fileList
      } else {
        this.fileList = fileList
      }
      if (info.file.status === 'done' || info.file.status === 'removed') {
        this.handlePathChange()
      }
    },
    checkImg(file) {
      const nameArr = (file.name || '').split('.')
      const fileType = nameArr[nameArr.length - 1].toLowerCase()
      if (['png', 'jpg', 'jpeg'].includes(fileType)) this.isImg = true
      else this.isImg = false
    },
    handleDelete() {
      if (this.mode == 'imgMode') {
        this.isImg = false
        this.fileList = []
        this.handlePathChange()
      }
    },
    handlePathChange() {
      let uploadFiles = this.fileList
      let doneFiles = []
      if (!uploadFiles || uploadFiles.length == 0) doneFiles = []
      else {
        uploadFiles.forEach((file) => {
          if (file.status === 'done') {
            const { name, size } = file
            const url = file.response.result
            doneFiles.push({ name, size, url })
          }
        })
      }
     const arr = doneFiles.map((file) => file.url)
    this.$emit('change', arr.length > 0 ? arr.join(',') : '', this.filePathMap(doneFiles, this.ids, this.typeName))
    },
    handlePreview(file) {
      this.$refs['JPreviewModal'].review(file)
    },
    filePathMap(obj, isInit, typeName) {
      if (typeof isInit === 'boolean' && isInit) {
        // 转换为上传组件中的上传列表
        let arr = []
        for (let i = 0; i < obj.length; i++) {
          let file = obj[i]
          if (file.delFlag === '1') break
          else {
            const { id, fileName: name, fileAddress: url, fileSize: size } = file
            arr.push({ id, name, url, size })
          }
        }
        return arr
      } else {
        // 转换成绑定值
        const ids = isInit // 原始id
        let map = obj.map((r, i) => {
          const { id, name: fileName, url: fileAddress, size: fileSize, typeName: busiType } = r
          return { id, fileName, fileAddress, fileSize, busiType }
        })
        if (ids && ids.length > 0) {
          let len1 = ids.length
          let len2 = obj.length
          if (len1 > len2) {
            let i = len2
            do {
              map.push({ id: ids[i], delFlag: '1', busiType: typeName })
              i++
            } while (len1 > i)
          }
        }
        return map
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .file-upload {
    width: var(--upload-width, 360px);
    height: var(--upload-height, 200px);
    padding: 0;
  }

  .file-upload :deep(.ant-upload) {
    margin: 0;
    padding: 0;
    height: calc(var(--upload-height) - 36px);
    /* 修正变量引用 */
  }

  .file-upload :deep(.ant-upload-drag) {
    height: calc(100% - 24px);
    width: 100%;
    padding: 0;
  }

  .file-upload-wrap {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    .flex-center {
      display: flex;
      align-items: center;
      flex-direction: column;
      width: 100%;

      .profile {
        margin-bottom: 6px;
        font-size: var(--icon-size, 24px) !important;
      }
    }

    > img {
      height: 100%;
    }

    &:hover .hover-mask {
      display: flex;
    }

    .hover-mask {
      display: none;
      font-size: 22px;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.3);

      :deep(i:last-child) {
        margin-left: 10px;
      }
    }

    .ant-upload-list-item-actions span {
      color: #fff;
    }

    div.ant-upload-text {
      line-height: 1.2;
      font-size: 12px !important;
      margin-top: 6px;
    }

    div.ant-upload-hint {
      font-size: 12px !important;
      color: rgba(0, 0, 0, 0.45);
    }

    p.ant-upload-drag-icon {
      margin-bottom: 6px;

      .anticon {
        font-size: var(--icon-size, 24px) !important;
      }
    }
  }

  .bottom-desc {
    color: rgba(0, 0, 0, 0.88);
    text-align: center;
    font-size: 12px;
    padding: 0;
    margin: 0;
    margin-top: 4px;
  }

  .ant-upload-drag-container {
    padding: 0 20px;
  }

  .ellipsis {
    max-width: 80%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
 ::v-deep .ant-upload-disabled {
    color: inherit !important;
  }
  .anticon {
    color:#fff;
  }
</style>
